export type Maybe<T> = T | undefined

export enum Language {
  German = "de",
  French = "fr",
  Italian = "it",
}

export function isLanguage(language: string): language is Language {
  return language === "de" || language === "fr" || language === "it"
}

export interface DateRange {
  from: Date;
  to: Date;
}